import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  destinations,
  happyCustomers,
  metrics,
  processSteps,
  serviceTracks,
  slides,
  spotlightCards,
} from '../content/siteData';

function Home() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((value) => (value + 1) % slides.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <main className="go-home" id="top">
      <section className="gop-slider" aria-label="Global opportunities featured slides">
        <div className="gop-slider__track">
          {slides.map((slide, index) => (
            <div
              key={slide.title}
              className={index === current ? 'gop-slide active' : 'gop-slide'}
              aria-hidden={index !== current}
            >
              <img src={slide.src} alt={slide.alt} className="gop-slide__img" />
              <div className="gop-slide__overlay" />
              <div className="gop-slide__caption">
                <span className="gop-slide__eyebrow">Vedanskrix Global Opportunities</span>
                <h1 className="gop-slide__title">{slide.title}</h1>
                <p className="gop-slide__text">{slide.description}</p>
                <div className="gop-slide__actions">
                  <Link to="/services" className="gop-btn gop-btn--primary">
                    Explore Services
                  </Link>
                  <Link to="/contact" className="gop-btn gop-btn--outline">
                    Book Counselling
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gop-slider__dots" role="tablist">
          {slides.map((slide, index) => (
            <button
              key={slide.title}
              className={index === current ? 'gop-slider__dot active' : 'gop-slider__dot'}
              onClick={() => setCurrent(index)}
              aria-label={`Slide ${index + 1}`}
              role="tab"
              aria-selected={index === current}
            />
          ))}
        </div>

        <button
          className="gop-slider__arr gop-slider__arr--prev"
          onClick={() => setCurrent((value) => (value - 1 + slides.length) % slides.length)}
          aria-label="Previous slide"
        >
          {'<'}
        </button>
        <button
          className="gop-slider__arr gop-slider__arr--next"
          onClick={() => setCurrent((value) => (value + 1) % slides.length)}
          aria-label="Next slide"
        >
          {'>'}
        </button>
      </section>

      <section className="gop-about">
        <div className="gop-container gop-about__inner">
          <div className="gop-about__text">
            <span className="gop-eyebrow">About Vedanskrix Global Opportunities</span>
            <h2>Your trusted partner for global study and visa planning.</h2>
            <p>
              Vedanskrix Global Opportunities supports students, working professionals, and
              families who want to move abroad with better preparation and less confusion.
            </p>
            <p>
              From country selection and profile assessment to documentation guidance, SOP review,
              and visa preparation, our process is designed to make every step clearer, more
              organized, and easier to manage.
            </p>
            <p>
              We focus on realistic planning instead of generic promises, so every applicant gets
              guidance aligned to profile strength, timeline, and destination goals.
            </p>
            <div className="gop-about__stats">
              {metrics.map((metric) => (
                <div key={metric.label} className="gop-astat">
                  <strong>{metric.value}</strong>
                  <span>{metric.label}</span>
                </div>
              ))}
            </div>
            <Link to="/contact" className="gop-btn gop-btn--primary">
              Get Free Counselling
            </Link>
          </div>

          <div className="gop-about__img-wrap">
            <img
              src="/global-opportunities-section.png"
              alt="Global opportunities guidance by Vedanskrix"
              className="gop-about__img"
            />
          </div>
        </div>
      </section>

      <section className="gop-happy-customers">
        <div className="gop-container">
          <div className="go-section-heading">
            <p className="go-section-label">Happy Customers</p>
            <h2>Clients value clear support, practical planning, and calmer decision-making.</h2>
          </div>

          <div className="gop-testimonial-grid">
            {happyCustomers.map((item) => (
              <article key={item.name + item.role} className="gop-testimonial-card">
                <p>{item.text}</p>
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="go-spotlight">
        <div className="go-container">
          <div className="go-section-heading">
            <p className="go-section-label">What We Focus On</p>
            <h2>One platform for study, work, and travel support.</h2>
          </div>

          <div className="go-spotlight__grid">
            {spotlightCards.map((card) => (
              <article key={card.title} className="go-spotlight-card">
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="go-destinations" id="destinations">
        <div className="go-container">
          <div className="go-section-heading">
            <p className="go-section-label">Preferred Destinations</p>
            <h2>Country guidance for UK, USA, NL, Canada, and AUS.</h2>
          </div>

          <div className="go-country-grid">
            {destinations.map((item) => (
              <article key={item.country} className="go-country-card">
                <strong>{item.country}</strong>
                <p>{item.focus}</p>
              </article>
            ))}
          </div>

          <div className="go-section-cta">
            <Link to="/destinations" className="gop-btn gop-btn--primary">
              View All Destination Details
            </Link>
          </div>
        </div>
      </section>

      <section className="go-services" id="services">
        <div className="go-container go-services__grid">
          <div className="go-services__intro">
            <p className="go-section-label">Service Stack</p>
            <h2>Built to support every major decision point in the journey.</h2>
            <p>
              We do not stop at broad advice. We help translate goals into a practical plan,
              cleaner documents, and a stronger application experience.
            </p>
          </div>

          <div className="go-services__panel">
            {serviceTracks.map((track) => (
              <div key={track.title} className="go-service-line">
                <span className="go-service-line__dot" />
                <div>
                  <strong>{track.title}</strong>
                  <p>{track.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="go-process" id="process">
        <div className="go-container">
          <div className="go-section-heading">
            <p className="go-section-label">Our Process</p>
            <h2>A guided flow that keeps your next move clear.</h2>
          </div>

          <div className="go-process__grid">
            {processSteps.map((item) => (
              <article key={item.step} className="go-process-card">
                <span>{item.step}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>

          <div className="go-section-cta">
            <Link to="/process" className="gop-btn gop-btn--primary">
              See Full Process
            </Link>
          </div>
        </div>
      </section>

      <section className="go-results" id="results">
        <div className="go-container go-results__grid">
          <div>
            <p className="go-section-label">Why Families and Professionals Trust Us</p>
            <h2>We make complicated processes feel structured and manageable.</h2>
          </div>

          <div className="go-results__quote">
            <p>
              Better planning, better communication, and better document quality can change the
              full rhythm of an international application. That is where we bring value.
            </p>
            <strong>Vedanskrix Advisory Approach</strong>
            <div className="go-results__action">
              <Link to="/success" className="gop-btn gop-btn--outline">
                Explore Why Clients Trust Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="gop-cta-banner">
        <div className="gop-container gop-cta-banner__inner">
          <div>
            <h2 className="gop-cta-banner__title">Ready to plan your next global move?</h2>
            <p className="gop-cta-banner__sub">
              Connect with Vedanskrix for structured support across admissions, visa planning, and
              application preparation.
            </p>
          </div>
          <div className="gop-cta-banner__actions">
            <Link to="/contact" className="gop-btn gop-btn--primary">
              Contact Us
            </Link>
            <a
              href="https://wa.me/918758637022"
              target="_blank"
              rel="noreferrer"
              className="gop-btn gop-btn--outline"
            >
              WhatsApp Chat
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
